import React from "react";

interface AboutProps {
  sectionRef: (el: HTMLElement | null) => void;
  companyName: string;
}

const About: React.FC<AboutProps> = ({ sectionRef, companyName }) => {
  return (
    <section id="about" ref={sectionRef} className="w-full py-20 md:py-24 bg-transparent text-text-primary overflow-hidden relative">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div className="space-y-8">
            <div className="inline-block px-4 py-1.5 bg-primary/10 text-primary text-sm font-bold tracking-wider rounded-full uppercase">
              About Our Mission
            </div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tighter leading-[0.9] text-text-primary">
              Empowering Growth through <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">Transparent Lending</span>
            </h2>
            <div className="space-y-6">
              <p className="text-xl md:text-2xl font-black leading-relaxed text-text-primary tracking-tight">
                {companyName} is a RBI-Registered NBFC dedicated to bridging the credit gap.
              </p>
              <p className="text-lg text-text-secondary font-medium leading-relaxed max-w-2xl">
                We are a pure-play Non-Banking Financial Company (NBFC), not a Fintech. We specialize exclusively in providing a wide array of loan products, including personal, business, and vehicle loans. We believe that accessible, straightforward credit is the key to economic stability. Please note, we do not offer any insurance services—our sole focus is empowering you with optimal lending solutions.
              </p>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0 lg:pl-10">
            <div className="absolute inset-0 bg-primary-light rounded-[2rem] translate-x-4 translate-y-4 -z-10" />
            <div className="bg-primary text-white p-10 md:p-14 shadow-xl rounded-[2rem] relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" />
              <h3 className="text-3xl font-bold mb-6">Financial Inclusion</h3>
              <p className="text-white/90 text-lg leading-relaxed mb-10">
                Our goal is to provide affordable and accessible loan facilities to individuals and businesses, especially those historically underserved by traditional banking establishments.
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-1 bg-secondary rounded-full" />
                <span className="text-white font-semibold tracking-wider text-sm">The {companyName} Team</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
